/**
 * ReportsHarvestInspectionsPersonNumberOfInspections
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectReportsHarvestInspectionsPersonValue } from '../../services/reportsHarvestInspectionsPeople/selectors';

interface Props {
    numberOfInspections?: ?number;
}

export class ReportsHarvestInspectionsPersonNumberOfInspections extends React.PureComponent<Props> {
    render() {
        const { numberOfInspections } = this.props;
        if (!numberOfInspections && numberOfInspections !== 0) return null;
        return numberOfInspections;
    }
}

const mapStateToProps = createStructuredSelector({
    numberOfInspections: makeSelectReportsHarvestInspectionsPersonValue(
        'numberOfInspections'
    )
});

export default connect(mapStateToProps)(
    ReportsHarvestInspectionsPersonNumberOfInspections
);
